const getters = {
  deployUploadApi: state => state.api.deployUploadApi,
  databaseUploadApi: state => state.api.databaseUploadApi,
  size: state => state.app.size,
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  roles: state => state.user.roles,
  user: state => state.user.user,
  permissions: state => state.user.permissions,
  permissionsList: state => state.user.permissionsList,
  organizationId: state => state.user.organizationId,
  project: state => state.user.project,
  loadMenus: state => state.user.loadMenus,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  socketApi: state => state.api.socketApi,
  imagesUploadApi: state => state.api.imagesUploadApi,
  baseApi: state => state.api.baseApi,
  fileUploadApi: state => state.api.fileUploadApi,
  updateAvatarApi: state => state.api.updateAvatarApi,
  qiNiuUploadApi: state => state.api.qiNiuUploadApi,
  sqlApi: state => state.api.sqlApi,
  swaggerApi: state => state.api.swaggerApi,
  sidebarRouters: state => state.permission.sidebarRouters,
  videoListCache: state => state.pageCache.videoListCache,
  videoListCacheByOrgId: state => (orgId) => {
    return state.pageCache.videoListCache.get(orgId)
  },
  videoListPlayback: state => state.videoListPlayback.videoListCacheReturn,
  videoListPlaybackByOrgId: state => (orgId) => {
    return state.videoListPlayback.videoListCacheReturn.get(orgId)
  }
}
export default getters
